import { render, staticRenderFns } from "./PageTree.vue?vue&type=template&id=1bcc643f&scoped=true"
import script from "./PageTree.vue?vue&type=script&lang=js"
export * from "./PageTree.vue?vue&type=script&lang=js"
import style0 from "./PageTree.vue?vue&type=style&index=0&id=1bcc643f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc643f",
  null
  
)

export default component.exports